// Centralised content data for the House of Numbardar landing page.

export const BRAND = {
  name: "House of Numbardar",
  tagline: "Delhi NCR · Est. 2006",
  legacyTag: "ESTABLISHED 1795 · DELHI NCR",
  phones: ["+91 928-999-1501"],
  whatsapp: "+919289991501",
  email: "hello@houseofnumbardar.com",
  rera: "RERA Reg. No: DLRERA2024A12345",
  address: "B-14, Vasant Vihar, New Delhi – 110 057",
  hours: "Monday – Saturday, 10 AM – 7 PM",
};

export const STATS = [
  { numeric: 40, prefix: "", suffix: "+", label: "Developer & Builder\nPartnerships" },
  { numeric: 2400, prefix: "₹", suffix: " Cr+", label: "Worth of Inventory\nCurated" },
  { numeric: 8, prefix: "", suffix: "", label: "Generations of\nLand Custodianship" },
  { numeric: 12, prefix: "", suffix: "", label: "Premium Markets\nAcross NCR" },
];

export const PILLAR_TAGLINES = [
  { numeral: "I", view: "capital", title: "The Capital Office", tagline: "Intelligence before investment" },
  { numeral: "II", view: "dealroom", title: "The Dealroom", tagline: "Where the finest assets change hands" },
  { numeral: "III", view: "estates", title: "The Estates", tagline: "A life uncommonly lived" },
  { numeral: "IV", view: "atelier", title: "The Atelier", tagline: "Built to last centuries" },
];

export const LINEAGE = [
  { gen: "I", name: "Dharam Singh", year: "1795", era: "First Numbardar of the Lineage" },
  { gen: "II", name: "Heera Singh", year: "1826", era: "Early 19th Century" },
  { gen: "III", name: "Mohladh Singh", year: "1856", era: "Mid 19th Century" },
  { gen: "IV", name: "Roop Ram Singh", year: "1886", era: "Late 19th Century" },
  { gen: "V", name: "Nihal Singh", year: "1916", era: "Early 20th Century" },
  { gen: "VI", name: "Rohtash Singh", year: "1946", era: "Mid 20th Century" },
  { gen: "VII", name: "Dinesh Yadav", year: "1974", era: "Late 20th Century" },
  {
    gen: "VIII",
    name: "Prashant Singh Yaduvanshi",
    year: "2000",
    era: "Current Leadership",
    sibling: { name: "Bhoomit Singh Yaduvanshi", year: "2003", era: "Current Leadership" },
  },
];

export const PILLAR_CARDS = [
  {
    numeral: "I",
    view: "capital",
    label: "WEALTH ADVISORY",
    title: "The Capital Office",
    italic: "Intelligence before investment.",
    bullets: [
      "Portfolio acquisition & exit strategy",
      "Legal due diligence & documentation",
      "Yield optimisation across asset classes",
    ],
    cta: "ENTER THE OFFICE",
    icon: "scale",
    image:
      "https://images.unsplash.com/photo-1521587760476-6c12a4b040da?auto=format&fit=crop&w=1400&q=80",
  },
  {
    numeral: "II",
    view: "dealroom",
    label: "PROPERTY MARKETPLACE",
    title: "The Dealroom",
    italic: "Where the finest assets change hands.",
    bullets: [
      "Pre-vetted ultra-luxury inventory",
      "Off-market & pre-launch access",
      "Pan-India coverage · International soon",
    ],
    cta: "ENTER THE DEALROOM",
    icon: "arch",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80",
  },
  {
    numeral: "III",
    view: "estates",
    label: "BESPOKE EXPERIENCES",
    title: "The Estates",
    italic: "A life uncommonly lived.",
    bullets: [
      "Heritage havelis, palaces & retreats",
      "Private chef · butler · chauffeur",
      "Curated events & itineraries",
    ],
    cta: "DISCOVER THE ESTATES",
    icon: "crown",
    image:
      "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=800&q=85",
  },
  {
    numeral: "IV",
    view: "atelier",
    label: "INTERIORS · BUILD",
    title: "The Atelier",
    italic: "Built to last centuries.",
    bullets: [
      "Bespoke interiors · India's finest designers",
      "Custom bungalow & villa construction",
      "Heritage restoration & turn-key delivery",
    ],
    cta: "EXPLORE THE ATELIER",
    icon: "compass",
    image:
      "https://images.unsplash.com/photo-1487958449943-2429e8be8625?auto=format&fit=crop&w=1400&q=80",
  },
];

export const PILLARS = [
  {
    numeral: "I",
    label: "WEALTH ADVISORY",
    title: ["The Capital", "Office"],
    view: "capital",
    italic: "For those who think in decades, not quarters.",
    body:
      "We manage real estate the way a private banker manages wealth — with portfolio thinking, tax efficiency, long-term return modelling, and complete discretion. End-to-end documentation, legal due diligence, resale strategy, and active portfolio management across asset classes.",
    services: [
      "Portfolio Acquisition & Exit Strategy",
      "Documentation & Legal Due Diligence",
      "Resale & Secondary Market Representation",
      "Yield Optimisation & Rental Management",
      "Cross-Asset Class Diversification",
      "NRI Property Management",
    ],
    cta: "ENTER THE OFFICE",
  },
  {
    numeral: "II",
    label: "PROPERTY MARKETPLACE",
    title: ["The", "Dealroom"],
    view: "dealroom",
    italic: "Where the finest assets change hands.",
    body:
      "Our curated marketplace features pre-vetted luxury inventory across Delhi NCR and beyond. Every listing is evaluated for location quality, builder credibility, financial merit, and growth trajectory before it earns a place in the Dealroom.",
    services: [
      "Residential: Bungalows, Villas, Penthouses, Apartments",
      "Commercial: Grade-A Office, Retail, SCO",
      "Land & Plotted Development",
      "Farmhouses & Agri-Land",
      "Pre-Launch & Off-Market Inventory",
      "Pan-India · International (Coming Soon)",
    ],
    cta: "ENTER THE DEALROOM",
  },
  {
    numeral: "III",
    label: "BESPOKE EXPERIENCES",
    title: ["The", "Estates"],
    view: "estates",
    italic: "Properties so exceptional, they become destinations.",
    body:
      "Numbardar Estates is our curated portfolio of handpicked heritage properties, private retreats, and grand landscape estates — managed exclusively by House of Numbardar for luxury stays, private events, and bespoke experiences.",
    services: [
      "Bespoke Private Stays (minimum 2 nights)",
      "Private Events: Weddings, Celebrations, Retreats",
      "Dedicated Chauffeur & Private Transfer",
      "Personal Chef & Curated Dining",
      "Concierge & Butler Services",
      "Curated Itinerary Design",
    ],
    cta: "DISCOVER THE ESTATES",
  },
  {
    numeral: "IV",
    label: "INTERIORS · BUILD",
    title: ["The", "Atelier"],
    view: "atelier",
    italic: "Bespoke interiors and heritage construction — coming soon.",
    body:
      "Curated by India's finest designers and built with the rigour of the finest construction houses. Atelier brings interior design and architectural construction under the Numbardar standard — from concept to move-in.",
    services: [
      "Bespoke Interior Design — Residential & Commercial",
      "Heritage Property Restoration & Renovation",
      "Custom Bungalow & Villa Construction",
      "Neo-Classical · Modern · Mughal-Heritage Styles",
      "Premium Material Sourcing — Domestic & Imported",
      "Turn-Key Delivery — concept to move-in",
    ],
    cta: "EXPLORE THE ATELIER",
  },
];

export const PROPERTIES = [
  {
    code: "NDB/LUT/0007",
    badge: "HOT DEAL",
    badgeTone: "hot",
    type: "ULTRA LUXURY · BUNGALOW",
    location: "Amrita Shergill Marg, Lutyens' Delhi",
    config: "6 BHK · 11,200 sq.ft · Plot 1.1 Acre",
    rate: "₹1,82,000 / sq.ft",
    value: "₹165 Cr",
    growth: "+22–28%",
    yield: null,
    image:
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1400&q=80",
    feature: true,
  },
  {
    code: "NDB/GCR/0042",
    badge: "OFF-MARKET",
    badgeTone: "muted",
    type: "ULTRA LUXURY · PENTHOUSE",
    location: "Golf Course Road, Gurugram",
    config: "4 BHK · 6,400 sq.ft · 32nd Floor",
    rate: "₹42,500 / sq.ft",
    value: "₹27.20 Cr",
    growth: "+38–44%",
    yield: "3.2% p.a.",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80",
  },
  {
    code: "NDB/SDL/0118",
    badge: "READY",
    badgeTone: "ready",
    type: "LUXURY · BUNGALOW",
    location: "Vasant Vihar, South Delhi",
    config: "5 BHK · 7,800 sq.ft · Plot 500 sq.yd",
    rate: "₹95,000 / sq.ft",
    value: "₹74.10 Cr",
    growth: "+18–24%",
    yield: null,
    image:
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1400&q=80",
  },
  {
    code: "NDB/DXP/0061",
    badge: "PRE-LAUNCH",
    badgeTone: "muted",
    type: "PREMIUM · APARTMENT",
    location: "Dwarka Expressway, Gurugram",
    config: "4 BHK · 3,800 sq.ft · 14th Floor",
    rate: "₹24,500 / sq.ft",
    value: "₹9.31 Cr",
    growth: "+34–42%",
    yield: "2.9% p.a.",
    image:
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1400&q=80",
  },
  {
    code: "NDB/FRH/0009",
    badge: "OFF-MARKET",
    badgeTone: "muted",
    type: "FARMHOUSE · ESTATE",
    location: "Westend Greens, New Delhi",
    config: "8 BHK · 14,000 sq.ft · 2.5 Acres",
    rate: "₹6.4 Cr / Acre",
    value: "₹46.0 Cr",
    growth: "+15–20%",
    yield: null,
    image:
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1400&q=80",
  },
  {
    code: "NDB/CYB/0023",
    badge: "READY",
    badgeTone: "ready",
    type: "GRADE-A · COMMERCIAL",
    location: "Cyber City, Gurugram",
    config: "Office Floor · 18,500 sq.ft · 22nd Fl",
    rate: "₹17,800 / sq.ft",
    value: "₹32.93 Cr",
    growth: "+12–18%",
    yield: "8.4% p.a.",
    image:
      "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=80",
  },
  {
    code: "NDB/NDA/0144",
    badge: "READY",
    badgeTone: "ready",
    type: "LUXURY · APARTMENT",
    location: "Sector 150, Noida",
    config: "5 BHK · 5,200 sq.ft · 22nd Floor",
    rate: "₹19,800 / sq.ft",
    value: "₹10.30 Cr",
    growth: "+28–34%",
    yield: "3.4% p.a.",
    image:
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1400&q=80",
  },
  {
    code: "NDB/SPR/0078",
    badge: "PRE-LAUNCH",
    badgeTone: "muted",
    type: "PREMIUM · VILLA",
    location: "Southern Peripheral Road, Gurugram",
    config: "4 BHK Villa · 4,400 sq.ft · Plot 360 sq.yd",
    rate: "₹38,200 / sq.ft",
    value: "₹16.80 Cr",
    growth: "+30–38%",
    yield: null,
    image:
      "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=1400&q=80",
  },
];

export const ESTATES = [
  {
    name: "Mountain Retreat",
    location: "Mukteshwar, Uttarakhand",
    availability: "From ₹1.85 L per night",
    image:
      "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?auto=format&fit=crop&w=1200&q=80",
  },
  {
    name: "Heritage Haveli",
    location: "Old Delhi · Chandni Chowk",
    availability: "Private Events · By Invitation",
    image:
      "https://images.unsplash.com/photo-1564507592333-c60657eea523?auto=format&fit=crop&w=1200&q=80",
  },
  {
    name: "Palace Courtyard",
    location: "Udaipur, Rajasthan",
    availability: "From ₹3.40 L per night",
    image:
      "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=1200&q=80",
  },
  {
    name: "Riverfront Bungalow",
    location: "Rishikesh, Uttarakhand",
    availability: "From ₹1.10 L per night",
    image:
      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80",
  },
];

export const REGIONS = [
  {
    name: "Lutyens' Delhi",
    sub: "12 Exclusive Estates",
    image:
      "https://images.unsplash.com/photo-1587474260584-136574528ed5?w=800&q=85",
  },
  {
    name: "Gurugram",
    sub: "48 Premium Homes · GCR · GCER · SPR · DXP",
    image:
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=900&q=80",
  },
  {
    name: "Noida & Greater Noida",
    sub: "31 Luxury Residences · Sector 44, 150, YEIDA",
    image:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=900&q=80",
  },
  {
    name: "South Delhi",
    sub: "22 Curated Properties · Vasant Vihar, GK, Panchsheel",
    image:
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=85",
  },
];

export const MARKET_MARQUEE = [
  "LUTYENS' DELHI",
  "SOUTH DELHI",
  "GURUGRAM",
  "NOIDA",
  "GREATER NOIDA",
  "FARIDABAD",
  "CHANDIGARH TRICITY",
  "MUMBAI (COMING SOON)",
  "DUBAI (COMING SOON)",
  "LONDON (COMING SOON)",
];

export const TESTIMONIALS = [
  {
    quote:
      "House of Numbardar didn't just find us a home — they found us a legacy. The discretion and attention to detail was unlike anything in Delhi's market.",
    name: "Rajiv & Priya Malhotra",
    detail: "Lutyens' Delhi · Bungalow Acquisition",
  },
  {
    quote:
      "Their network is extraordinary. Three off-market options within a week, properties that simply do not appear on any public listing platform.",
    name: "Sunil Agarwal",
    detail: "Golf Course Road · Gurugram",
  },
  {
    quote:
      "From the first consultation, they understood our precise vision completely. We were treated not as clients, but as family — from inquiry to handover.",
    name: "Dr. Anjali Sharma",
    detail: "Sector 44 · Noida",
  },
];

// Self-hosted hero clip (downloaded from the Drive URL provided by the
// owner, transcoded to a web-friendly 1280×720 H.264 MP4 at ~5MB).
export const HERO_VIDEO_SOURCES = [
  "/media/hero-estate.mp4",
];

// Mobile fallback — luxury estate stills replace the video below 768px to
// preserve battery, data, and avoid forced-autoplay quirks.
export const HERO_MOBILE_IMAGE =
  "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=1400&q=85";

// Backwards-compat alias
export const HERO_VIDEO = HERO_VIDEO_SOURCES[0];

export const ADVISORY_BG =
  "https://images.unsplash.com/photo-1600210491892-03d54c0aaf87?auto=format&fit=crop&w=2400&q=85";
